import { render, staticRenderFns } from "./RTMP.vue?vue&type=template&id=00c1272a&scoped=true&"
import script from "./RTMP.vue?vue&type=script&lang=ts&"
export * from "./RTMP.vue?vue&type=script&lang=ts&"
import style0 from "./RTMP.vue?vue&type=style&index=0&id=00c1272a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1272a",
  null
  
)

export default component.exports